import './index.less'
import endPointUrl from '@/images/track/endPoint.png'
import loadingUrl from '@/images/track/loadingPoint.png'
import positionUrl from '@/images/track/position.png'
import startPointUrl from '@/images/track/startPoint.png'
import unloadingUrl from '@/images/track/unloadingPoint.png'
import { DatePicker, Empty, Input, message, Modal, Select, Slider, Spin, Icon } from 'antd'
import moment from 'moment'
import React, { Component, useState, useEffect } from "react";
import { Link } from 'react-router-dom'
import QueryRecordCard from './components/QueryRecordCard'
import navCarUrl from '@/images/track/navCar.png'
import AMapLoader from '@amap/amap-jsapi-loader'
import http from "@/http";
import { API } from "@/http/api";
// import 'animate.css'
import './map.css'

import {
    PlusOutlined,
    CloseCircleFilled,
    CloseOutlined,
    LeftOutlined,
    RightOutlined,
} from '@ant-design/icons';
const personKey = '7abd890f6aec8d7b6a237c6f56b2d876' // 个人申请的key

const { Option } = Select
const { RangePicker } = DatePicker


class IndexPage extends React.Component {
    // 状态初始化
    state = {
        value: 1,// 定位-0，轨迹-1
        isShowOperate: false,// 定位-0，轨迹-1
        plat: null,// 车牌号
        trackList: [],
        locationData: [],
        show: false,
        isAddMapPoint: false,
        map: '',
        AMap: '',
        timer: '',
        speed: 0,
        navigator: [],
        trackData: [],
        createTime: '',
        pathSimplifierIns: '',
        selectList: [
            {
                name: '定位',
                code: 0,
            },
            {
                name: '轨迹',
                code: 1,
            },
        ],
        pageNo: 1,
        totalPages: 1,
        trackQueryTime: [
            {
                start: '',
                end: '',
            },
        ],
        activeIndex: 0,
        idenity: 'cargoOwner',
        date: [null, null],
        code: '',
        isLoading: false,
        markers: [],
        newMaps: '',

    }
    componentDidMount() {
        this.initMap();
        window._AMapSecurityConfig = {
            securityJsCode: "bf9d8b714b9bf384b89822aad2f909d7", // 个人安全密钥Jscode
        }
    }
    // 初始化地图
    initMap = () => {
        AMapLoader.load({
            key: personKey,
            version: '2.0',
            plugins: ['AMap.MoveAnimation', 'AMap.ToolBar'], // 巡航器动画插件
            AMapUI: {
                version: '1.1',
                plugins: ['misc/PathSimplifier', 'overlay/SimpleMarker'], // AMapUI插件
            },
        })
            .then((AMap) => {
                // 初始化地图

                const map = new AMap.Map('container', {
                    //rotateEnable: true,
                    //pitchEnable: true,
                    zoom: 13,
                    //pitch: 30,
                    //rotation: -15,
                    viewMode: '2D', //开启3D视图,默认为关闭
                    zooms: [5, 18],
                    // center:[116.333926,39.997245],
                })
                this.setState({
                    map: map,
                    AMap: AMap,
                })
                // getUrlParams(map, AMap)
                // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
                map.addControl(
                    new AMap.ToolBar({
                        // 简易缩放模式，默认为 false
                        liteStyle: true,
                    }),
                )
            })
            .catch((e) => {
                // console.log(e)
            })
    }
    // 创建marker信息窗体
    createInfoWindow = (point, isDelete, marker, index) => {
        const info = document.createElement('div')
        info.className = 'infoWindow'
        // const position = [point.lng, point.lat]
        // point.position = position
        // 定义车牌号标题
        const top = document.createElement('div')
        const titleD = document.createElement('div')
        if (point.plate) {
            titleD.className = 'infoWindowTitle'
            titleD.innerHTML = point.plate

            top.appendChild(titleD)
            info.appendChild(top)
        }

        // 定义查询时间、定位地址、坐标、速度
        const eleTime = document.createElement('div')
        const eleAddress = document.createElement('div')
        const elePoint = document.createElement('div')
        const eleSpeed = document.createElement('div')
        const eleresidenceTime = document.createElement('div')
        // 创建删除dom isDelete
        const eleDelete = document.createElement('div')
        if (point.time) {
            eleTime.className = 'infoWindowTime'
            eleTime.innerHTML =
                "<span style='display: inline-block; width: 70px; color: #818599; font-size: 14px; line-height: 22px;'>查询时间</span>" +
                point.time || '-'
        }
        if (point.address) {
            eleAddress.className = 'infoWindowAddress'
            eleAddress.innerHTML =
                "<span style='display: inline-block; width: 70px; color: #818599; font-size: 14px; line-height: 22px;'>定位地址</span>" +
                point.address
        }
        if (point.speed) {
            eleSpeed.className = 'infoWindowSpeed'
            eleSpeed.innerHTML =
                "<span style='display: inline-block; width: 70px; color: #818599; font-size: 14px; line-height: 22px;'>速度</span>" +
                point.speed +
                'Km/h' || '-'
        }
        if (point.residenceTime) {
            eleresidenceTime.className = 'infoWindowResidenceTime'
            eleresidenceTime.innerHTML =
                "<span style='display: inline-block; width: 70px; color: #818599; font-size: 14px; line-height: 22px;'>停留时间</span>" +
                point.residenceTime || '-'
        }
        // console.log('==point.position==================================');
        // console.log(point.position);
        // console.log('===point.position=================================');
        if (point.position[0]) {
            // 经纬度保留小数点后6位
            const lng =
                String(point.position[0]) &&
                String(point.position[0]).split('.')[0] +
                '.' +
                String(point.position[0]).split('.')[1].slice(0, 6)
            const lat =
                String(point.position[1]) &&
                String(point.position[1]).split('.')[0] +
                '.' +
                String(point.position[1]).split('.')[1].slice(0, 6)
            elePoint.className = 'infoWindowPoint'
            elePoint.innerHTML =
                "<span style='display: inline-block; width: 70px; color: #818599; font-size: 14px; line-height: 22px;'>坐标</span>" +
                lng +
                ',' +
                lat
        }
        if (isDelete) {
            eleDelete.className = 'infoWindowDelete'
            eleDelete.innerHTML = '<span>删除标点</span>'
            eleDelete.onclick = () => {
                marker.setMap(null)
                this.state.markers.pop()
                this.setState({
                    markers: marker
                })
                this.state.newMaps.clearInfoWindow()
            }
        }
        info
            .appendChild(eleTime)
            .appendChild(eleAddress)
            .appendChild(elePoint)
            .appendChild(eleSpeed)
            .appendChild(eleDelete)
            .appendChild(eleresidenceTime)

        return info
    }
    // 海量点防抖处理
    debounce = (fn, wait, immediate) => {
        const _this = this
        return function () {
            if (_this.state.timer) clearTimeout(_this.state.timer)
            if (immediate) {
                // 如果已经执行过，不再执行
                const callNow = !_this.state.timer
                _this.state.timer = setTimeout(() => {
                    _this.state.timer = null
                }, wait)
                if (callNow) {
                    fn()
                }
            } else {
                _this.state.timer = setTimeout(() => {
                    fn()
                }, wait)
            }
        }
    }
    // 地图打点
    addMarker = (
        data,
        flag = false,
        isShow = true,
        maps = null,
        AMaps = null,
        isDelete = false,
    ) => {
        const create_map = maps ? maps : this.state.map
        const create_AMap = AMaps ? AMaps : this.state.AMap
        if (!flag) {
            create_map.clearMap()
        }
        const markerArr = []
        data.map(async (point, index) => {
            // 创建Marker
            const marker = new create_AMap.Marker({
                map: create_map,
                icon: point.url,
                position: point.position,
                offset:
                    this.state.value == 0 && data.length > 1
                        ? new create_AMap.Pixel(-10, -30)
                        : new create_AMap.Pixel(-10, -12),
            })
            if (isDelete) {
                markerArr.push(marker)
            }
            var position = new create_AMap.LngLat(point.position[0], point.position[1]); //传入经纬度
            this.state.map.setCenter(position); //简写 设置地图中心点
            // create_map.setFitView(null, true, [150, 60, 100, 60])
            // 设置标点尺寸
            const markerContent = document.createElement('div')
            const markerImg = document.createElement('img')
            markerImg.className = 'markerlnglat'
            // markerImg.className = 'animate__animated animate__bounceInDown'
            // setTimeout(() => {
            //   markerImg.className = ''
            // }, 500)

            markerImg.src = point.url
            markerImg.setAttribute('width', '32px')
            markerImg.setAttribute('height', '32px')
            markerContent.appendChild(markerImg)
            marker.setContent(markerContent)
            this.setState({
                newMaps: create_map
            })
            marker.on('mouseover', () => {
                if (isShow) {
                    infoWindow.open(create_map, marker.getPosition())
                }
            })
            marker.on('click', () => {
                // 缩放级别
                create_map.setZoomAndCenter(13, point.position)
            })
            marker.on('mouseout', () => {
                // 隐藏信息窗体
                if (flag) {
                    setTimeout(() => {
                        create_map.clearInfoWindow()
                    }, 5000)
                    return
                }
                create_map.clearInfoWindow()
            })
            // 自定义marker信息窗体
            const infoWindow = new create_AMap.InfoWindow({
                isCustom: true,
                content: this.createInfoWindow(point, isDelete, marker, index),
                offset: new create_AMap.Pixel(16, -22),
            })
        })
    }
    // 创建轨迹
    createTrack = (dataSource, flag = false) => {
        if (!dataSource) {
            return
        }
        const _this = this
        new window.AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], function (PathSimplifier, $) {
            if (window.pathSimplifierIns) {
                // 防止轨迹叠加
                window.pathSimplifierIns.setData([])
            }
            if (!PathSimplifier.supportCanvas) {
                alert('当前环境不支持 Canvas！')
                return
            }
            const colors = ['#00BF7A']
            const pathSimplifierIns = new PathSimplifier({
                zIndex: 100,
                map: _this.state.map, //所属的地图实例
                onTopWhenSelected: false,
                clickToSelectPath: false,
                getPath: function (pathData, pathIndex) {
                    return pathData.path
                },
                //返回鼠标悬停时显示的信息
                getHoverTitle: function (pathData, pathIndex, pointIndex) {
                    const pointCode = pathData.pointArr[pointIndex] // 轨迹点pointCode

                    const createDate = new Date(_this.state.createTime).getTime();
                    const fn = () => {
                        if (pointIndex >= 0) {
                            /*
                             * 鼠标悬停在某个轨迹节点上
                             * 防抖处理
                             * */
                            const config = {
                                api: API.queryPointInfoApi,
                                data: {
                                    createDate: createDate,
                                    ponitId: pointCode
                                },
                            }
                            http(config).then((res) => {
                                if (res.code === 200) {
                                    const { address, lng, lat, plate, queryDate, speed, residenceTime } = res.result
                                    return new _this.state.AMap.InfoWindow({
                                        isCustom: true, //使用自定义窗体
                                        content: _this.createInfoWindow({
                                            position: [lng, lat],
                                            plate,
                                            time: queryDate,
                                            address,
                                            speed,
                                            residenceTime,
                                        }),
                                        offset: new _this.state.AMap.Pixel(16, -22),
                                    }).open(_this.state.map, pathData.path[pointIndex])
                                }
                            })
                        }
                    }
                    _this.debounce(fn, 500)()
                },
                //轨迹线的样式
                renderOptions: {
                    renderAllPointsIfNumberBelow: 20000,
                    pathLineStyle: {
                        strokeStyle: '#00BF7A',
                        lineWidth: 6,
                        dirArrowStyle: true,
                    },
                    keyPointStyle: {
                        radius: 5,
                        fillStyle: '#fff',
                        strokeStyle: '#2E4AFF',
                        lineWidth: '4',
                    },
                    keyPointOnSelectedPathLineStyle: {
                        radius: 5,
                        fillStyle: '#fff',
                        strokeStyle: '#2E4AFF',
                        lineWidth: '4',
                    },
                    startPointStyle: {},
                    getPathStyle: function (pathItem, zoom) {
                        const color = colors[pathItem.pathIndex % colors.length],
                            lineWidth = 6
                        return {
                            pathLineStyle: {
                                strokeStyle: color,
                                lineWidth: lineWidth,
                            },
                            pathNavigatorStyle: {
                                fillStyle: color,
                            },
                        }
                    },
                },
            })
            // 监听鼠标移出点位事件
            pathSimplifierIns.on('pointMouseout', () => {
                const fn = () => {
                    _this.state.map.clearInfoWindow()
                }
                _this.debounce(fn, 500)()
            })
            window.pathSimplifierIns = pathSimplifierIns
            // 鼠标点击时不触发事件
            pathSimplifierIns.on('pointClick', () => { })
            let lineArr = []
            let pointArr = []

            const createNewDataSource = []
            // 地图打点
            // 判断轨迹是否标红   起始点与终点打点
            let showredData = []
            let lat = ''
            let lng = ''
            if (dataSource.length >= 1) {
                dataSource &&
                    dataSource.map((item) => {
                        item &&
                            item.map((key, index) => {

                                // 起始点与终点打点
                                if (index === 0 || index === item.length - 1) {
                                    // 获取到第一个和最后节点保存到createNewDataSource里
                                    let pointCode = key.pointCode

                                    let createDate = _this.state.createTime
                                    const config = {
                                        api: API.queryPointInfoApi,
                                        data: {
                                            createDate: createDate,
                                            ponitId: pointCode
                                        },
                                    }
                                    http(config).then((res) => {
                                        if (res.code === 200) {
                                            createNewDataSource.push({
                                                plate: key.plate,
                                                position: key.position,
                                                pointCode: key.pointCode,
                                                url: key.url,
                                                residenceTime: res.residenceTime,
                                                address: res.result.address,
                                                time: res.result.queryDate,
                                                speed: res.result.speed,
                                            })
                                            _this.addMarker(createNewDataSource)
                                        }
                                    })
                                }
                                // 判断轨迹是否标红
                                if (key.isRed) {
                                    // 获取需要标红的list
                                    showredData.push(key.position)
                                    if (lat != key.position[1] && lng != key.position[0]) {
                                        let pointCode = key.pointCode

                                        let createDate = _this.state.createTime
                                        const config = {
                                            api: API.queryPointInfoApi,
                                            data: {
                                                createDate: createDate,
                                                ponitId: pointCode
                                            },
                                        }
                                        http(config).then((res) => {
                                            if (res.code === 200) {
                                                createNewDataSource.push({
                                                    plate: key.plate,
                                                    position: key.position,
                                                    pointCode: key.pointCode,
                                                    url:
                                                        '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
                                                    residenceTime: res.result.residenceTime,
                                                    address: res.result.address,
                                                    time: res.result.queryDate,
                                                    speed: res.result.speed,
                                                })
                                                _this.addMarker(createNewDataSource)
                                            }
                                        })
                                    }
                                    lat = key.position[1]
                                    lng = key.position[0]
                                }
                            })
                    })
            }
            const d = []
            dataSource &&
                dataSource.map((key) => {
                    key &&
                        key.map((item) => {
                            lineArr.push(item.position)
                            pointArr.push(item.pointCode)
                        })

                    d.push({
                        name: '轨迹',
                        path: lineArr,
                        pointArr,
                    })
                    pathSimplifierIns.setData(d)
                })
                
            // 获取所有标点的经纬度坐标
            const allPoints = d[0].path;
            
            // 计算标点的边界范围
            // const bounds = new _this.state.AMap.Bounds();
            // allPoints.forEach((point,index) => {
            //     // console.log("point",point);
            //     const arr =[]
            //     if(index == 0 || index == allPoints.length -1){
            //         arr.push(point)
            //     }
            //     console.log("arr",arr,"arr");
            //     bounds.extend(arr);
            // });
            // console.log("bounds",bounds);
            // var myBounds=new _this.state.AMap.Bounds([88.379391,20.861536],[117.379391,41.861536]);
            // _this.state.map.setBounds(myBounds);
            // 设置地图视野以适应边界范围
            // _this.state.map.setBounds([113.85023,34.998582],[113.621602,34.666345]);
            // _this.state.map.setFitView() // 视野自适应

            _this.setState({
                trackData: dataSource.length,
                pathSimplifierIns: pathSimplifierIns
            })
        })
    }
    // 创建巡航器
    createPathNavigator = () => {
        const _this = this
        new window.AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], function (PathSimplifier, $) {
            let pathNavigator = []
            let navg = null
            for (let i = 0; i < _this.state.trackData; i++) {
                // 创建轨迹巡航器
                navg = _this.state.pathSimplifierIns.createPathNavigator(i, {
                    //loop: true,
                    //autoRotate: false, // 禁止调整方向
                    speed: _this.state.speed * 50 + 50,
                    pathNavigatorStyle: {
                        initRotateDegree: 140,
                        width: 38,
                        height: 38,
                        // 使用图片
                        content: PathSimplifier.Render.Canvas.getImageContent(navCarUrl, onload, onerror),
                        strokeStyle: null,
                        fillStyle: null,
                        //经过路径的样式
                        pathLinePassedStyle: {
                            lineWidth: 6,
                            strokeStyle: 'black',
                            dirArrowStyle: {
                                stepSpace: 15,
                                strokeStyle: 'red',
                            },
                        },
                    },
                })
                navg.start()
                pathNavigator.push(navg)
                _this.setState({
                    navigator: pathNavigator
                })
            }
        })
    }
    onload = () => {
        this.state.pathSimplifierIns.render()
    }
    // 下拉选择
    onSelect = (val) => {
        this.setState({
            value: Number(val),
            show: false,
            speed: 0,
        })
    }
    // 确定查询
    queryOk = async () => {
        if (!this.state.plat) {
            message.warning('请输入车牌号')
            return
        }
        if (!this.state.value) {
            // 定位
            this.queryPosition()
            this.setState({
                isShowOperate: false
            })
        } else {
            this.queryTrack()
            this.setState({
                isShowOperate: true,
            })
            this.state.navigator.map((ngt) => {
                // 销毁巡航器
                ngt.destroy()
            })
        }
    }
    queryRecord = async (bool) => {
        if (bool) {
            this.state.pageNo = 1
            await this.setPageNo(this.state.pageNo)
        }
        const config = {
            api: !this.state.value ? API.getPositionRecordsApi : API.getTrackRecordsApi,
            data: {
                pageNo: this.state.pageNo,
                pageSize: 10,
                plate: this.state.plat,
            },
        }
        http(config).then((res) => {
            if (res.code === 200) {
                // 定位数据
                if (!this.state.value) {
                    this.setState({
                        locationData: res.result.records
                    })
                } else {
                    // 轨迹数据
                    this.setState({
                        trackList: res.result.records
                    })

                }
                if (!Number(res.result.total)) {
                    return
                }
                this.setState({
                    totalPages: res.result.pages
                })
            }
        })
        this.setState({
            show: true,
        })
    }
    // 定位查询
    queryPosition = () => {
        const configs = {
            api: API.getPositionDataApi,
            data: {
                plate: this.state.plat,
            },
        }
        http(configs).then((res) => {
            if (window.pathSimplifierIns) {
                // 防止轨迹叠加
                window.pathSimplifierIns.setData([])
            }
            if (res.code == 200) {
                this.addMarker([
                    {
                        position: [res.result.lng, res.result.lat],
                        url: positionUrl,
                        time: res.result.queryDate,
                        speed: res.result.speed,
                        ...res.result,

                    },
                ])
            } else {
            }
        })
    }
    // 轨迹查询
    queryTrack = () => {
        // 获取查询数据
        this.setState({
            trackData: [],
            isLoading: true
        })
        const configs = {
            api: API.getTrackQueryApi,
            data: {
                plate: this.state.plat,
                start: this.state.trackQueryTime[0].start,
                end: this.state.trackQueryTime[0].end
            },
        }
        http(configs).then((res) => {
            if (res.code == 200) {
                const time = res.result.createDate
                this.setState({
                    isLoading: false,
                    createTime: time
                })
                const lineArr = []
                const dataSourceArr = []
                res.result.pointList.map((child, index) => {
                    lineArr.push({
                        position: [child.lng, child.lat],
                        url:
                            index === 0
                                ? startPointUrl
                                : index === res.result.pointList.length - 1
                                    ? endPointUrl
                                    : '',
                        plate: res.result.plate,
                        pointCode: child.trackQueryId,
                        isRed: child.isRed,
                        residenceTime: child.residenceTime,
                        positioningTime: child.positioningTime
                    })
                })

                dataSourceArr.push(lineArr)
                // 判断是轨迹还是定位
                // 创建轨迹
                this.createTrack(dataSourceArr)
            } else {
                // 没有数据
                this.setState({
                    isLoading: false,
                    isShowOperate: false
                })
            }
        })
    }
    // 查询记录
    handleQueryRecord = (e) => {
        const position = [e.lng, e.lat]
        const data = [
            {
                ...e,
                position: position,
                url: positionUrl,
            },
        ]

        if (!this.state.value) {
            // 定位
            if (window.pathSimplifierIns) {
                // 防止轨迹叠加
                window.pathSimplifierIns.setData([])
            }
            this.addMarker(data)
            this.setState({
                isShowOperate: false,
            })
        } else {
            // 轨迹查询
            this.setState({
                isLoading: true,
            })
            const config = {
                api: API.pointListByQueryId,
                path: {
                    queryId: e.id
                },
            }
            http(config).then((res) => {
                if (res.code == 200) {
                    const { pointList, plate } = res.result
                    const time = res.result.createDate
                    this.setState({
                        isLoading: false,
                        createTime: time
                    })
                    const lineArr = []

                    pointList.map((child, index) => {
                        lineArr.push({
                            position: [child.lng, child.lat],
                            url:
                                index === 0
                                    ? startPointUrl
                                    : index === pointList.length - 1
                                        ? endPointUrl
                                        : '',
                            plate: plate,
                            pointCode: child.trackQueryId,
                            isRed: child.isRed,
                            residenceTime: child.residenceTime,
                            positioningTime: child.positioningTime
                        })
                    })

                    this.createTrack([lineArr])
                } else {
                    this.setState({
                        isLoading: false,
                    })
                }
            })
            this.setState({
                isShowOperate: true,
            })
            this.state.navigator.map((ngt) => {
                ngt.destroy()
            })
        }
    }
    // 设置速度
    handleSliderChange = (value) => {
        this.setState({
            speed: value,
        })
        this.handleDestroy()
    }
    // 开始
    handleStart = () => {
        this.state.navigator.map((ngt) => {
            ngt.destroy()
        })
        this.createPathNavigator()
    }
    // 暂停
    handlePause = () => {
        this.state.navigator.map((ngt) => {
            ngt.pause()
        })
    }
    // 继续
    handleResume = () => {
        this.state.navigator.map((ngt) => {
            ngt.resume()
        })
    }
    // 关闭
    handleDestroy = () => {
        this.state.navigator.map((ngt) => {
            ngt.destroy()
        })
    }
    // 地图选点
    addMapPoint = () => {
        if (this.state.markers.length > 5) {
            message.warning('最多添加6个标点')
            return
        }
        this.setState({
            isAddMapPoint: true,
        })
        this.processAddress()
    }
    processAddress = () => {
        window.addEventListener('message', this.call, false)
    }
    setPageNo = (pageNo) => {
        this.setState({
            pageNo
        })
    }
    // 分页首页
    homePage = async () => {
        if (this.state.pageNo <= 1) {
            return
        } else {
            this.state.pageNo = 1
            await this.setPageNo(this.state.pageNo)
            this.queryRecord()
        }
    }
    // 上一页
    prevPage = async () => {
        if (this.state.pageNo <= 1) {
            return
        } else {
            this.state.pageNo--
            await this.setPageNo(this.state.pageNo)
            this.queryRecord()
        }
    }
    // 下一页
    nextPage = async () => {
        if (this.state.pageNo >= this.state.totalPages) {
            return
        } else {
            this.state.pageNo++
            await this.setPageNo(this.state.pageNo)
            this.queryRecord()
        }
    }
    call = (event) => {
        const _this = this
        const loc = event.data
        if (loc && loc.module == 'locationPicker') {
            _this.setState({
                isAddMapPoint: false
            })
            const { latlng, poiaddress } = loc
            const { lat, lng } = latlng
            const markers = []
            markers.push({
                address: poiaddress,
                position: [lng, lat],
                url: positionUrl,
            })
            this.setState({
                markers: markers
            })
            _this.addMarker(
                [
                    {
                        address: poiaddress,
                        position: [lng, lat],
                        url: positionUrl,
                    },
                ],
                true,
                true,
                null,
                null,
                true,
            )
            window.removeEventListener('message', _this.call, false)
        }
    }
    // 日期选择1
    handleSelectTimeOne = (dates, dateStrings) => {
        this.state.trackQueryTime[0].start = dateStrings[0]
        this.state.trackQueryTime[0].end = dateStrings[1]

        // setTrackQueryTime([...trackQueryTime])
        this.setState({
            date: [dateStrings[0], dateStrings[1]]
        })
        // setDate([dateStrings[0], dateStrings[1]])
    }
    // 日期限制条件
    disabledDate = (current) => {
        return current && current > moment().endOf('day')
    }
    render() {
        return (
            <div className='trackQueryWrapper'>
                {/* 轨迹查询条件 */}
                <div className='queryCondition'>
                    <div className='queryConditionOperate'>
                        <div className='timeIntervalT'>
                            <div className='queryConditionOperateL'>
                                <div className='queryConditionOperateF'>
                                    <Select
                                        style={{ width: '140px' }}
                                        onSelect={this.onSelect}
                                        value={this.state.selectList[this.state.value].name}
                                    >
                                        {
                                            this.state.selectList && this.state.selectList.map(item => {
                                                return <Option key={item.code} value={item.code}>{item.name}</Option>
                                            })
                                        }
                                    </Select>
                                    <Input
                                        value={this.state.plat}
                                        className='myInput'
                                        style={{ width: '140px' }}
                                        placeholder="车牌号"
                                        onChange={(e) => {
                                            this.setState({
                                                plat: e.target.value
                                            })
                                        }}
                                    />
                                    {this.state.value ? (
                                        <RangePicker
                                            allowClear={true}
                                            style={{ width: '370px' }}
                                            showTime={{
                                                defaultValue: [
                                                    moment('00:00:00', 'HH:mm:ss'),
                                                    moment('23:59:59', 'HH:mm:ss'),
                                                ],
                                            }}
                                            value={
                                                this.state.date[0]
                                                    ? [
                                                        moment(this.state.date[0], 'YYYY-MM-DD h:mm:ss'),
                                                        moment(this.state.date[1], 'YYYY-MM-DD h:mm:ss'),
                                                    ]
                                                    : null
                                            }
                                            onChange={this.handleSelectTimeOne}
                                            disabledDate={this.state.disabledDate}
                                        />
                                    ) : null}
                                    <div
                                        className='operateBtnWrapper'
                                        style={{ marginLeft: !this.state.value ? '0px' : '16px' }}
                                    >
                                        <div className='queryOk' onClick={this.queryOk}>
                                            确定查询
                                        </div>
                                        <div
                                            className='queryRecord'
                                            onClick={() => {
                                                this.queryRecord(true)
                                            }}
                                        >
                                            查询记录
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='queryConditionOperateR'></div>
                        </div>

                    </div>
                </div>
                {/* 地图定位、轨迹 */}
                <div className='trackQueryMain'>
                    {/* 地图 */}
                    <div className='trackQueryMap' id="container">
                        {this.state.isLoading ? <Spin tip="查询中..." className='mapLoading'></Spin> : null}
                    </div>
                    {/* 地图轨迹操作 */}
                    {this.state.value && this.state.isShowOperate ? (
                        <div className='trackOperateWrapper'>
                            <div className='btn' onClick={this.handleStart}>
                                开始
                            </div>
                            <div className='btn' onClick={this.handlePause}>
                                暂停
                            </div>
                            <div className='btn' onClick={this.handleResume}>
                                继续
                            </div>
                            <div className='btn' onClick={this.handleDestroy}>
                                关闭
                            </div>
                            <div className='speed'>
                                <span>速度：</span>
                                <div className='sliderWrapper'>
                                    <span className='slow'>慢</span>
                                    <Slider tooltipVisible={false} onChange={this.handleSliderChange} />
                                    <span className='fast'>快</span>
                                </div>
                            </div>
                            <div className='addPoint' onClick={this.addMapPoint}>
                                <PlusOutlined className="icons" />
                                <span className='point'>标点</span>
                            </div>
                        </div>
                    ) : null}
                    {/* 查询记录 */}
                    {this.state.show ? (
                        <div className='queryRecordWrapper'>
                            <div className='queryRecordWrapperTitle'>
                                <span className='label'>{this.state.selectList[this.state.value].name}查询记录</span>
                                <CloseOutlined className='iconclose'
                                    onClick={() => {
                                        this.setState({
                                            show: false
                                        })
                                    }} />
                            </div>
                            <div className='queryRecordCardWrapper'>
                                <QueryRecordCard
                                    data={this.state.value ? this.state.trackList : this.state.locationData}
                                    type={this.state.value}
                                    queryRecord={this.handleQueryRecord}
                                />
                                {(this.state.value && this.state.trackList.length === 0) || (!this.state.value && this.state.locationData.length === 0) ? (
                                    <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="暂无查询记录"
                                        style={{ width: '100%', height: '100%' }}
                                    />
                                ) : null}
                            </div>
                            <div className='pagination'>
                                <div className='totalPages'>{this.state.pageNo + '/' + this.state.totalPages}</div>
                                <div className='paginationMain'>
                                    <div onClick={this.homePage} style={{ color: this.state.pageNo <= 1 ? '#B4B6BF' : null }}>
                                        首页
                                    </div>
                                    <div>
                                        <LeftOutlined className='iconclose'
                                            style={{ color: this.state.pageNo <= 1 ? '#B4B6BF' : null }}
                                            onClick={this.prevPage} />
                                    </div>
                                    <div>
                                        <RightOutlined className='iconclose'
                                            style={{ color: this.state.pageNo >= this.state.totalPages ? '#B4B6BF' : null }}
                                            onClick={this.nextPage} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
                {this.state.isAddMapPoint && (
                    <div className='mapPoint'>
                        <div className='mapHeader'>
                            <span>位置</span>

                            <Icon
                                type="iconclose"
                                className='iconclose'
                                onClick={() => {
                                    this.setState({
                                        isAddMapPoint: false
                                    })
                                }}
                            />
                        </div>
                        <iframe
                            id="mapPage"
                            width="900"
                            height="721"
                            frameBorder="0"
                            src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=GU6BZ-S4BW6-RQISY-EEMRZ-T4E5H-XCFIV&referer=myapp"
                        ></iframe>
                    </div>
                )}
            </div>
        )
    }

}

export default IndexPage